export const labelColors = [
    {value: "bg-blue-100 text-blue-700", label: "Azul"},
    {value: "bg-emerald-100 text-emerald-700", label: "Verde"},
    {value: "bg-amber-100 text-amber-700", label: "Amarelo"},
    {value: "bg-red-100 text-red-700", label: "Vermelho"},
    {value: "bg-violet-100 text-violet-700", label: "Roxo"},
];

const labelColorClasses = {
    "bg-blue-100 text-blue-700": "!bg-blue-100 !text-blue-700 hover:!bg-blue-200",
    "bg-emerald-100 text-emerald-700": "!bg-emerald-100 !text-emerald-700 hover:!bg-emerald-200",
    "bg-amber-100 text-amber-700": "!bg-amber-100 !text-amber-700 hover:!bg-amber-200",
    "bg-red-100 text-red-700": "!bg-red-100 !text-red-700 hover:!bg-red-200",
    "bg-violet-100 text-violet-700": "!bg-violet-100 !text-violet-700 hover:!bg-violet-200",
};

const labelSolidColorClasses = {
    "bg-blue-100 text-blue-700": "bg-blue-600 text-white hover:bg-blue-700",
    "bg-emerald-100 text-emerald-700": "bg-emerald-600 text-white hover:bg-emerald-700",
    "bg-amber-100 text-amber-700": "bg-amber-500 text-white hover:bg-amber-600",
    "bg-red-100 text-red-700": "bg-red-600 text-white hover:bg-red-700",
    "bg-violet-100 text-violet-700": "bg-violet-600 text-white hover:bg-violet-700",
};

const labelColorHexValues = {
    "bg-blue-100 text-blue-700": "#2563eb",
    "bg-emerald-100 text-emerald-700": "#059669",
    "bg-amber-100 text-amber-700": "#f59e0b",
    "bg-red-100 text-red-700": "#dc2626",
    "bg-violet-100 text-violet-700": "#7c3aed",
};

export const isHexColor = color => /^#[0-9a-f]{6}$/i.test(color ?? "");

export const getLabelColorClass = color => {
    if (isHexColor(color)) return "";
    if (labelColorClasses[color]) return labelColorClasses[color];
    if (color?.includes("blue") || color === "azul") return labelColorClasses["bg-blue-100 text-blue-700"];
    if (color?.includes("green") || color?.includes("emerald") || color === "verde") return labelColorClasses["bg-emerald-100 text-emerald-700"];
    if (color?.includes("red") || color === "vermelho") return labelColorClasses["bg-red-100 text-red-700"];
    if (color?.includes("amber") || color === "amarelo") return labelColorClasses["bg-amber-100 text-amber-700"];
    if (color?.includes("violet") || color === "roxo") return labelColorClasses["bg-violet-100 text-violet-700"];
    return "!bg-slate-100 !text-slate-700 hover:!bg-slate-200";
};

export const getLabelSolidColorClass = color => {
    const normalizedColor = Object.keys(labelColorClasses).find(value => getLabelColorClass(color) === labelColorClasses[value]);
    return labelSolidColorClasses[normalizedColor] ?? "bg-slate-600 text-white hover:bg-slate-700";
};

export const getLabelColorStyle = color => {
    if (!isHexColor(color)) return undefined;
    const red = parseInt(color.slice(1, 3), 16);
    const green = parseInt(color.slice(3, 5), 16);
    const blue = parseInt(color.slice(5, 7), 16);
    const textColor = ((red * 299 + green * 587 + blue * 114) / 1000) > 160 ? "#0f172a" : "#ffffff";
    return {backgroundColor: color, color: textColor};
};

export const getColorPickerValue = color => isHexColor(color) ? color : (labelColorHexValues[color] ?? "#2563eb");

export const isValidLabelColor = color => isHexColor(color) || labelColors.some(option => option.value === color);

export const normalizeTypedColor = value => {
    const trimmedValue = value.trim();
    if (!trimmedValue) return "";
    const hexadecimalValue = trimmedValue.replace(/^#/, "").replace(/[^0-9a-f]/gi, "").slice(0, 6);
    return `#${hexadecimalValue}`;
};
